/**
 * NOON ALL DAY — "Ship to" country selector (CH-178).
 *
 * Progressive enhancement over a native <dialog> + native {% form 'localization' %}. The country
 * <button type="submit" name="country_code"> elements submit the form natively (this file is NOT
 * required for switching country — it only adds the modal open/close, scroll-lock, aria state and
 * an optional filter for long lists). No price/currency/IP logic here — Shopify Markets is the
 * source of truth.
 */
(function () {
  var dialog = document.getElementById('ship-to-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var openers = Array.prototype.slice.call(document.querySelectorAll('[data-ship-to-open]'));
  var lastOpener = null;
  var scrollY = 0;

  function open(opener) {
    if (dialog.open) return;
    lastOpener = opener || null;

    // Scroll-lock the background (native <dialog> does not lock body scroll). Mirrors assets/dialog.js.
    scrollY = window.scrollY;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';

    dialog.showModal(); // native: focus-trap + Escape + top layer + ::backdrop
    document.dispatchEvent(new CustomEvent('nad:ship-to:opened')); // CH-189: analytics (GTM/pixels)

    if (lastOpener) lastOpener.setAttribute('aria-expanded', 'true');

    var focusTarget =
      dialog.querySelector('[data-ship-to-filter]') || dialog.querySelector('[data-ship-to-close]');
    if (focusTarget) {
      try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
    }
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () { open(btn); });
  });

  dialog.querySelectorAll('[data-ship-to-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  // Backdrop click = a click that lands on the <dialog> element itself, outside its inner content.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) close();
  });

  // Fires on Escape (native) and on close(). Restore scroll, aria and focus.
  dialog.addEventListener('close', function () {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });

    openers.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });

    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    lastOpener = null;
  });

  // CH-189: analytics — emit the chosen country on the native localization form submit (fires just
  // before the full-page navigation that switches market). Namespaced nad:ship-to:* for GTM etc.
  var shipToForm = document.getElementById('ShipToForm');
  if (shipToForm) {
    shipToForm.addEventListener('submit', function (event) {
      var btn = event.submitter || document.activeElement;
      var value = btn && btn.getAttribute && btn.getAttribute('name') === 'country_code' ? btn.value : null;
      document.dispatchEvent(new CustomEvent('nad:ship-to:country-selected', { detail: { country: value } }));
    });
  }

  // Optional filter (rendered only for long country lists).
  var filter = dialog.querySelector('[data-ship-to-filter]');
  if (filter) {
    var rows = Array.prototype.slice.call(dialog.querySelectorAll('[data-ship-to-country]'));
    var groups = Array.prototype.slice.call(dialog.querySelectorAll('[data-ship-to-group]'));
    var noResults = dialog.querySelector('[data-ship-to-noresults]');

    filter.addEventListener('input', function () {
      var q = filter.value.trim().toLowerCase();
      var anyVisible = false;

      rows.forEach(function (row) {
        var hay = row.getAttribute('data-country-search') || '';
        var match = !q || hay.indexOf(q) !== -1;
        row.hidden = !match;
        if (match) anyVisible = true;
      });

      groups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-ship-to-country]:not([hidden])');
      });

      if (noResults) noResults.hidden = anyVisible;
    });
  }
})();
